module.exports = __webpack_public_path__ + "media/images/logo/vipio-logo-white-c05ec949f2b05fa28991f9c76b56d844.svg";